// @noflow
import messages from './intl';
import theme from '~/core/themes/main';

export const getValueColor = ({ value }) => (value.get('status') === 'OFF' ? theme.mediumGrey : theme.mainBrandColor);

export const getValueLabel = ({ formatMessage, value }) =>
    formatMessage(value.get('status') === 'OFF' ? messages.off : messages.on);

export const updateValue = event =>
    event.getIn(['value', 'status']) === 'OFF'
        ? event.setIn(['value', 'status'], 'ON')
        : event.setIn(['value', 'status'], 'OFF');

export const defaultEventValue = { status: 'OFF' };

export const getDefaultSchedule = () => ({
    monday: [
        { value: { status: 'ON' }, start: 390 },
        { value: { status: 'OFF' }, start: 510 },
        { value: { status: 'ON' }, start: 960 },
        { value: { status: 'OFF' }, start: 1290 }
    ],
    tuesday: [
        { value: { status: 'ON' }, start: 390 },
        { value: { status: 'OFF' }, start: 510 },
        { value: { status: 'ON' }, start: 960 },
        { value: { status: 'OFF' }, start: 1290 }
    ],
    wednesday: [
        { value: { status: 'ON' }, start: 390 },
        { value: { status: 'OFF' }, start: 510 },
        { value: { status: 'ON' }, start: 960 },
        { value: { status: 'OFF' }, start: 1290 }
    ],
    thursday: [
        { value: { status: 'ON' }, start: 390 },
        { value: { status: 'OFF' }, start: 510 },
        { value: { status: 'ON' }, start: 960 },
        { value: { status: 'OFF' }, start: 1290 }
    ],
    friday: [
        { value: { status: 'ON' }, start: 390 },
        { value: { status: 'OFF' }, start: 510 },
        { value: { status: 'ON' }, start: 960 },
        { value: { status: 'OFF' }, start: 1290 }
    ],
    saturday: [
        { value: { status: 'ON' }, start: 390 },
        { value: { status: 'OFF' }, start: 510 },
        { value: { status: 'ON' }, start: 960 },
        { value: { status: 'OFF' }, start: 1290 }
    ],
    sunday: [
        { value: { status: 'ON' }, start: 390 },
        { value: { status: 'OFF' }, start: 510 },
        { value: { status: 'ON' }, start: 960 },
        { value: { status: 'OFF' }, start: 1290 }
    ]
});



// WEBPACK FOOTER //
// ./src/components/widgets/schedule/schedule-type/active-plugs/index.js